import request from '@/utils/http';
// 电商预约列表数据
export const getEcommerceList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/loadElsTasksDatas`,
        method: 'get',
        params
    });
};

// 运输单查询列表数据
export const getTransportList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/loadTasksDatas`,
        method: 'get',
        params
    });
};

// 电商预约（运输单查询）-仓内异常
export const saveWarehouseAbnormal = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveWarehouseAbnormal`,
        method: 'post',
        data
    });
};

// 根据code从数据字典获取
export const getDictionaryDetailByCode = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};

// 电商预约-菜鸟物流详情
export const loadElsLogisticsHistory = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/loadElsLogisticsHistory`,
        method: 'post',
        data
    });
};

// 电商预约（运输单查询）-送货预约
export const saveTaskReservation = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveTaskReservation`,
        method: 'post',
        data
    });
};

// 电商预约（运输单查询）-配送改约
export const saveTaskConversion = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveTaskConversion`,
        method: 'post',
        data
    });
};

// 电商预约（运输单查询）-配送异常
export const saveDistributeAbnormal = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveDistributeTransportAbnormal`,
        method: 'post',
        data
    });
};

// 运输单查询-双击详情
export const getEtTaskMaterielItem = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getEtTaskMaterielItem`,
        method: 'post',
        data
    });
};

// 运输单查询-设备绑定/取消绑定
export const updateDeviceGps = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/updateDeviceGps`,
        method: 'get',
        params
    });
};